import { IconButton, IconButtonProps, IconButtonSize, IconButtonVariant } from '../IconButton';
import React, { MutableRefObject } from 'react';
import { joinClassNames } from '../../utils';
import styles from './Fullscreen.module.scss';
import { IconSize } from '../../enums';
import { MaximiseIcon } from '../Graphics';
import { useFullscreen } from './useFullscreen';

type EnterFullscreenButtonProps = Omit<IconButtonProps, 'icon' | 'onClick' | 'size' | 'title'> & {
  title?: string;
  variant?: IconButtonVariant;
  size?: IconButtonSize;
  fullscreenContainerRef: MutableRefObject<HTMLDivElement | null>;
};
export const EnterFullscreenIconButton = ({
  fullscreenContainerRef,
  className,
  size = IconButtonSize.Small,
  ...props
}: EnterFullscreenButtonProps) => {
  const fullscreen = useFullscreen();
  const classNames = joinClassNames(styles.enterFullscreenIconButton, className);

  const iconSize: IconSize = size === IconButtonSize.Small ? IconSize.Mini : IconSize.Standard;
  return (
    <IconButton
      icon={<MaximiseIcon size={iconSize} />}
      onClick={async () => {
        const container = fullscreenContainerRef.current;
        if (container) {
          await fullscreen.request(container);
        }
      }}
      variant={IconButtonVariant.SolidLight}
      title="View in full screen"
      className={classNames}
      size={size}
      {...props}
    />
  );
};
